import IndividualPrints from './IndividualPrints.jsx';

export default IndividualPrints
